"use client";

import { Tabs } from "@/components/ui/tabs";
import { usePublisherTabs } from "./usePublisherTabs";
import type {
  PublisherGame,
  PublisherTopSellerGame,
  PublisherGameFollowers,
  PublisherGameWishlist,
  PublisherEventFeedItem,
} from "../../types";
import type { PublisherGameType, EventType } from "../../config";
import type { PublisherGameFollowersSort } from "../../api/getPublisherGameFollowers";
import type { PublisherGamesSort } from "../../utils/publisherGamesSort";

interface PublisherPageTabsProps {
  initialGames: PublisherGame[];
  initialTotal: number;
  initialTopSellers: PublisherTopSellerGame[];
  initialTopSellersTotal: number;
  initialGameFollowers: PublisherGameFollowers[];
  initialGameFollowersTotal: number;
  initialGameWishlist: PublisherGameWishlist[];
  initialGameWishlistTotal: number;
  initialEvents: PublisherEventFeedItem[];
  initialEventsTotal: number;
  pageSize: number;
  clanid: number;
  type: PublisherGameType;
  comingSoon: boolean;
  cc: string;
  followersSort: PublisherGameFollowersSort;
  gamesSort: PublisherGamesSort;
  eventType: EventType;
  gameFilter: number | null;
  filteredGameName: string | null;
}

export function PublisherPageTabs({
  initialGames,
  initialTotal,
  initialTopSellers,
  initialTopSellersTotal,
  initialGameFollowers,
  initialGameFollowersTotal,
  initialGameWishlist,
  initialGameWishlistTotal,
  initialEvents,
  initialEventsTotal,
  pageSize,
  clanid,
  type,
  comingSoon,
  cc,
  followersSort,
  gamesSort,
  eventType,
  gameFilter,
  filteredGameName,
}: PublisherPageTabsProps) {
  const tabs = usePublisherTabs({
    initialGames,
    initialTotal,
    initialTopSellers,
    initialTopSellersTotal,
    initialGameFollowers,
    initialGameFollowersTotal,
    initialGameWishlist,
    initialGameWishlistTotal,
    initialEvents,
    initialEventsTotal,
    pageSize,
    clanid,
    type,
    comingSoon,
    cc,
    followersSort,
    gamesSort,
    eventType,
    gameFilter,
    filteredGameName,
  });

  return (
    <Tabs
      tabs={tabs}
      defaultTab="games"
      syncWithUrl
      queryKey="tab"
      replaceHistory
      transformSearchParams={(params, nextTabId) => {
        // Не тягнемо між табами пагінацію/сорт (вони таб-специфічні і засмічують URL).
        // useListPagination сам знову запише їх, коли користувач буде взаємодіяти зі списком.
        params.delete("page");
        params.delete("pageSize");
        params.delete("sort");
        params.delete("coming_soon");
        params.delete("type");
        params.delete("cc");
        params.delete("event_type");
        params.delete("game_filter");
        // Якщо колись захочеш зробити allowlist по табах — тут найкраще місце.
        void nextTabId;
        return params;
      }}
    />
  );
}
